import Helper from './Helper';

class ScrollToNextElement {

  constructor(config = {}) {
    const {
      buttonSelector
    } = config;

    this.buttonSelector = document.querySelectorAll(buttonSelector);
    this.buttonSelectorArray = Array.prototype.slice.call(this.buttonSelector);
    if (this.buttonSelector && this.buttonSelectorArray.length > 0) {
      this.buttonSelectorArray.forEach((button) => {
        this.scrollOnClick(button);
      });
    }
  }

  scrollOnClick(button) {
    button.addEventListener("click", (e) => {
      e.preventDefault();
      const nextElement = this.findNextElement(button);
      console.log(nextElement);
      this.scrollTo(nextElement);
    });
  }

  findNextElement(el) {
    const sibling = el.parentNode.nextElementSibling;
    return (sibling) ? sibling : false;
  }

  scrollTo(element) {
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(element) //- 150
    });
  }

}

export default ScrollToNextElement;
